import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';

// eslint-disable-next-line @coursera-web/custom-rules/i18n-import-rule
import _t from 'i18n!nls/xdp';

import type { AiReviewSummaryQuery, AiReviewSummaryQueryVariables } from './__generated__/AiReviewSummaryQuery';

const AI_REVIEW_SUMMARY_QUERY = gql`
  query AiReviewSummaryQuery($key: String!) {
    ExternallyAccessibleNostosV1Resource {
      getAllProperties(job_name: "merchandising_ai_review", keys: $key) {
        elements {
          id
          content
        }
      }
    }
  }
`;

export const useAiReviewSummary = (courseId: string) => {
  // eslint-disable-next-line import/no-named-as-default-member
  const language = _t.getLocale();
  const isCorrectLanguage = language === 'en';

  const { data, loading, error } = useQuery<AiReviewSummaryQuery, AiReviewSummaryQueryVariables>(
    AI_REVIEW_SUMMARY_QUERY,
    {
      variables: { key: `COURSE!~${courseId}` },
      skip: !isCorrectLanguage || !courseId || !GrowthDiscoveryExperiments.get('enableAiReviews'),
      fetchPolicy: 'cache-first',
    }
  );

  return { data, loading, error };
};
